export const ROOT = '/AvailableJobAPI';
export const LIST = `${ROOT}/getjobpage`;
export const EXPORT = `${ROOT}/export`;
export const JOB_TITLE = `${ROOT}/getjobtitleddl`;
export const POSITION = `${ROOT}/getpositionddl`;
